import { Injectable } from '@angular/core';

/** ? */
@Injectable()
export class StorageService {
  public set(key: string, val?: any): void {
    if (val == null) {
      delete localStorage[key];
    } else {
      const value = JSON.stringify(val);
      debug('storage', 'setting key', key, value);
      localStorage[key] = value;
    }
  }

  public get(key: string): any {
    try {
      return JSON.parse(localStorage[key]);
    } catch (e) {
      return undefined;
    }
  }
}
